export interface CampoJuegoJSON {
  cj_id: string | null;
  cj_nombre: string;
  cj_clubid: number;
  cj_domicilio: string;
  cj_proid: number;
  cj_localidad: string;
  cj_cod_postal: string;
  cj_nro_telefono: string;
  cj_largo: number;
  cj_ancho: number;
  cj_cjtid: number;
  cj_cjtiid: number | null;
  cj_cjtpid: number;
  cj_cjttid: number | null;
  cj_capacidad: number;
  cj_agregar_tribuna: boolean;
  cj_tablero_electronico: boolean;
  cj_control_acceso: boolean;
  cj_vestuarios: boolean;
  cj_vestuarios_acceso: boolean;
  cj_posicion_mapa_latitud: string;
  cj_posicion_mapa_longitud: string;
  cj_observaciones: string;
  cj_activa: boolean;
  cj_fedid: number;
  cj_tiene_tribunas: boolean;
  cj_tiene_iluminacion: boolean;
}

export class CampoJuego {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private clubid: number,
    private domicilio: string,
    private proid: number,
    private localidad: string,
    private codPostal: string,
    private nroTelefono: string,
    private largo: number,
    private ancho: number,
    private cjtid: number,
    private cjtiid: number,
    private cjtpid: number,
    private cjttid: number,
    private capacidad: number,
    private agregarTribuna: boolean,
    private tableroElectronico: boolean,
    private controlAcceso: boolean,
    private vestuarios: boolean,
    private vestuariosAcceso: boolean,
    private posicionMapaLatitud: string,
    private posicionMapaLongitud: string,
    private observaciones: string,
    private activa: boolean,
    private fedid: number,
    private tieneTribunas: boolean,
    private tieneIluminacion: boolean
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    clubid: number,
    domicilio: string,
    proid: number,
    localidad: string,
    codPostal: string,
    nroTelefono: string,
    largo: number,
    ancho: number,
    cjtid: number,
    cjtiid: number,
    cjtpid: number,
    cjttid: number,
    capacidad: number,
    agregarTribuna: boolean,
    tableroElectronico: boolean,
    controlAcceso: boolean,
    vestuarios: boolean,
    vestuariosAcceso: boolean,
    posicionMapaLatitud: string,
    posicionMapaLongitud: string,
    observaciones: string,
    activa: boolean,
    fedid: number,
    tieneTribunas: boolean,
    tieneIluminacion: boolean
  ) {
    return new this(
      id,
      nombre,
      clubid,
      domicilio,
      proid,
      localidad,
      codPostal,
      nroTelefono,
      largo,
      ancho,
      cjtid,
      cjtiid,
      cjtpid,
      cjttid,
      capacidad,
      agregarTribuna,
      tableroElectronico,
      controlAcceso,
      vestuarios,
      vestuariosAcceso,
      posicionMapaLatitud,
      posicionMapaLongitud,
      observaciones,
      activa,
      fedid,
      tieneTribunas,
      tieneIluminacion
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: CampoJuego) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: CampoJuegoJSON) {
    return CampoJuego.createFrom(
      entity.cj_id,
      entity.cj_nombre,
      entity.cj_clubid,
      entity.cj_domicilio,
      entity.cj_proid,
      entity.cj_localidad,
      entity.cj_cod_postal,
      entity.cj_nro_telefono,
      entity.cj_largo,
      entity.cj_ancho,
      entity.cj_cjtid,
      entity.cj_cjtiid ? entity.cj_cjtiid : 0,
      entity.cj_cjtpid,
      entity.cj_cjttid ? entity.cj_cjttid : 0,
      entity.cj_capacidad,
      entity.cj_agregar_tribuna,
      entity.cj_tablero_electronico,
      entity.cj_control_acceso,
      entity.cj_vestuarios,
      entity.cj_vestuarios_acceso,
      entity.cj_posicion_mapa_latitud,
      entity.cj_posicion_mapa_longitud,
      entity.cj_observaciones,
      entity.cj_activa,
      entity.cj_fedid,
      entity.cj_tiene_tribunas,
      entity.cj_tiene_iluminacion
    );
  }

  toJSON(): CampoJuegoJSON {
    console.log('this.getCjtiid() > ', this.getCjtiid());
    return {
      cj_id: this.getId(),
      cj_nombre: this.getNombre(),
      cj_clubid: this.getClubid(),
      cj_domicilio: this.getDomicilio(),
      cj_proid: this.getProid(),
      cj_localidad: this.getLocalidad(),
      cj_cod_postal: this.getCodPostal(),
      cj_nro_telefono: this.getNroTelefono(),
      cj_largo: this.getLargo(),
      cj_ancho: this.getAncho(),
      cj_cjtid: this.getCjtid(),
      cj_cjtiid: this.getCjtiid() > 0 ? this.getCjtiid() : null,
      cj_cjtpid: this.getCjtpid(),
      cj_cjttid: this.getCjttid() > 0 ? this.getCjttid() : null,
      cj_capacidad: this.getCapacidad(),
      cj_agregar_tribuna: this.getAgregarTribuna(),
      cj_tablero_electronico: this.getTableroElectronico(),
      cj_control_acceso: this.getControlAcceso(),
      cj_vestuarios: this.getVestuarios(),
      cj_vestuarios_acceso: this.getVestuariosAcceso(),
      cj_posicion_mapa_latitud: this.getPosicionMapaLatitud(),
      cj_posicion_mapa_longitud: this.getPosicionMapaLongitud(),
      cj_observaciones: this.getObservaciones(),
      cj_activa: this.getActiva(),
      cj_fedid: this.getFedid(),
      cj_tiene_tribunas: this.getTieneTribunas(),
      cj_tiene_iluminacion: this.getTieneIluminacion(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getClubid(): number {
    return this.clubid;
  }

  getDomicilio(): string {
    return this.domicilio;
  }

  getProid(): number {
    return this.proid;
  }

  getLocalidad(): string {
    return this.localidad;
  }

  getCodPostal(): string {
    return this.codPostal;
  }

  getNroTelefono(): string {
    return this.nroTelefono;
  }

  getLargo(): number {
    return this.largo;
  }

  getAncho(): number {
    return this.ancho;
  }

  getCjtid(): number {
    return this.cjtid;
  }

  getCjtiid(): number {
    return this.cjtiid;
  }

  getCjtpid(): number {
    return this.cjtpid;
  }

  getCjttid(): number {
    return this.cjttid;
  }

  getCapacidad(): number {
    return this.capacidad;
  }

  getAgregarTribuna(): any {
    return this.agregarTribuna;
  }

  getTableroElectronico(): any {
    return this.tableroElectronico;
  }

  getControlAcceso(): any {
    return this.controlAcceso;
  }

  getVestuarios(): any {
    return this.vestuarios;
  }

  getVestuariosAcceso(): any {
    return this.vestuariosAcceso;
  }

  getPosicionMapaLatitud(): string {
    return this.posicionMapaLatitud;
  }

  getPosicionMapaLongitud(): string {
    return this.posicionMapaLongitud;
  }

  getObservaciones(): any {
    return this.observaciones;
  }

  getActiva(): any {
    return this.activa;
  }

  getFedid(): number {
    return this.fedid;
  }

  getTieneTribunas(): boolean {
    return this.tieneTribunas;
  }
  getTieneIluminacion(): boolean {
    return this.tieneIluminacion;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setClubid(value: number): void {
    this.clubid = value;
  }

  setDomicilio(value: string): void {
    this.domicilio = value;
  }

  setProid(value: number): void {
    this.proid = value;
  }

  setLocalidad(value: string): void {
    this.localidad = value;
  }

  setCodPostal(value: string): void {
    this.codPostal = value;
  }

  setNroTelefono(value: string): void {
    this.nroTelefono = value;
  }

  setLargo(value: number): void {
    this.largo = value;
  }

  setAncho(value: number): void {
    this.ancho = value;
  }

  setCjtid(value: number): void {
    this.cjtid = value;
  }

  setCjtiid(value: number): void {
    this.cjtiid = value;
  }

  setCjtpid(value: number): void {
    this.cjtpid = value;
  }

  setCjttid(value: number): void {
    this.cjttid = value;
  }

  setCapacidad(value: number): void {
    this.capacidad = value;
  }

  setAgregarTribuna(value: any): void {
    this.agregarTribuna = value;
  }

  setTableroElectronico(value: any): void {
    this.tableroElectronico = value;
  }

  setControlAcceso(value: any): void {
    this.controlAcceso = value;
  }

  setVestuarios(value: any): void {
    this.vestuarios = value;
  }

  setVestuariosAcceso(value: any): void {
    this.vestuariosAcceso = value;
  }

  setPosicionMapaLatitud(value: string): void {
    this.posicionMapaLatitud = value;
  }

  setPosicionMapaLongitud(value: string): void {
    this.posicionMapaLongitud = value;
  }

  setObservaciones(value: any): void {
    this.observaciones = value;
  }

  setActiva(value: any): void {
    this.activa = value;
  }

  setFedid(value: number): void {
    this.fedid = value;
  }

  setTieneTribunas(value: boolean): void {
    this.tieneTribunas = value;
  }
  setTieneIluminacion(value: boolean): void {
    this.tieneIluminacion = value;
  }
}
